<template>
  <el-container class="is-vertical" style="flex-shrink: 0">
    <el-main class="login-register">
      <div class="headings">
        <h2>Create teacher account</h2>
      </div>
      <div class="form-cnt">
         <el-form ref="registerForm" :model="register" :rules="rules">
              <div class="socials">
                <!-- <a href="#" class="auth-button facebook">
                    <span class="icon"><img src="/icons/facebook.svg" alt=""></span>
                    <span class="text">Log in with <b>Facebook</b></span>
                </a> -->
                <a href="/api/connect/google" class="auth-button google-plus">
                  <span class="icon">
                    <span class="circle">
                      <img src="/static/google.svg" alt="">
                    </span>
                  </span>
                  <span class="text">Register with <b>Google</b></span>
                </a>
                <!-- <a href="#" class="auth-button twitter">
                    <span class="icon"><img src="/icons/twitter.svg" alt=""></span>
                    <span class="text">Log in with <b>Twitter</b></span>
                </a> -->
              </div>
              <el-row el-row type="flex" :gutter="20">
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <label>
                    <span>Username</span>
                    <el-form-item prop="username">
                      <el-input
                              type="email"
                              placeholder="Enter your username"
                              v-model="register.username">
                      </el-input>
                    </el-form-item>
                  </label>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <label>
                    <span>Email</span>
                    <el-form-item prop="email">
                      <el-input
                              type="email"
                              placeholder="Enter your email"
                              v-model="register.email">
                      </el-input>
                    </el-form-item>
                  </label>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <label>
                    <span>Password</span>
                    <el-form-item prop="password">
                      <el-input
                              type="password"
                              placeholder="Enter your password"
                              v-model="register.password">
                      </el-input>
                    </el-form-item>
                  </label>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" class="d-flex align-center plan-title">
                  Choose subscription plan:
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
                  <el-button-group class="w-100 plan">
                    <el-button type="primary" plain class="w-50" :class="{active: plan === 'free'}" @click="setPlan('free')">Free</el-button>
                    <el-button type="success" plain class="w-50" icon="el-icon-star-on" :class="{active: plan === 'premium'}"  @click="setPlan('premium')">Premium</el-button>
                  </el-button-group>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="plan === 'premium'">
                  <div id='card-wrapper'></div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-show="plan === 'premium'" class="d-flex align-center">
                  <div id="cardForm">
                    <el-form-item prop="cardNumber">
                      <el-input
                              name="number"
                              type="text"
                              placeholder="Card Number"
                              v-model="register.cardNumber">
                      </el-input>
                    </el-form-item>
                    <div class="exiry-cvc">
                      <el-form-item prop="expiry">
                        <el-input
                                name="expiry"
                                type="text"
                                placeholder="MM/YY"
                                v-model="register.expiry">
                        </el-input>
                      </el-form-item>
                      <el-form-item prop="cvc">
                        <el-input
                                name="cvc"
                                type="text"
                                placeholder="CVC"
                                v-model="register.cvc">
                        </el-input>
                      </el-form-item>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <div class="actions flex-center" style="margin-top: 30px;">
                <el-button type="success" @click="submitForm('registerForm')">Sign up</el-button>
              </div>
            </el-form>
      </div>
      </div>
    </el-main>

  </el-container>
</template>

<script>
  import Card from 'card'

  export default {
    name: 'Register',
    data () {
      return {
        plan: "free",
        register: {
          username: "",
          email: "",
          password: "",
          cardNumber: "",
          expiry: "",
          cvc: ""
        },
        rules: {
          username: [
            {required: true, message: 'Please input username', trigger: 'blur'},
          ],
          email: [
            {required: true, message: 'Please input email address', trigger: 'blur'},
            {type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change']},
          ],
          password: [
            {required: true, message: 'Password should not be blank', trigger: ['blur', 'change']},
          ]
        },
        cardRules: {
          cardNumber: [
            {required: true, message: ' ', trigger: ['blur', 'change']},
          ],
          expiry: [
            {required: true, message: ' ', trigger: ['blur', 'change']},
          ],
          cvc: [
            {required: true, message: ' ', trigger: ['blur', 'change']},
          ]
        }
      }
    },
    mounted: function () {
      this.$nextTick(() => {
        let card = new Card({
          form: "#cardForm",
          container: '#card-wrapper',
//          width: 200
//          formSelectors: {
//            numberInput: "#cardForm .cardNumber",
//            expiryInput: "#cardForm .cardExpire",
//            cvcInput: "#cardForm .cardCvc",
//            nameInput: "#cardForm .cardName"
//          },
        });
      });
    },
    methods: {
      setPlan(plan) {
        if (plan === "premium") {
          Object.assign(this.rules, this.cardRules)
        } else {
          delete this.rules.cardNumber;
          delete this.rules.expiry;
          delete this.rules.cvc;
        }
        this.plan = plan;
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.register.email = this.register.email.toLowerCase();
            this.axios.post(this.$store.state.API_URL + 'auth/local/register', this.register).then((response) => {
              this.$store.state.user = response.data.user;
              this.$store.state.jwt = response.data.jwt;
              localStorage.setItem('jwt', response.data.jwt);

              this.$store.commit("setState", {loggedIn: true});
              this.$router.push('/my-library');
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },

    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/pages/RegisterTeacher.vue